import {HttpClient, HttpClientRequest} from "@fig/libs/shared/utils/http";
import {serialize} from "@fig/libs/shared/utils/url";

export let configuration: {
  baseUrl: string;
} | null = null;

let client: HttpClient;

export const setConfig = (baseUrl: string) => {
  if (configuration) {
    throw "API not configured";
  }

  client = new HttpClient(baseUrl, "camel", "camel");

  configuration = {
    baseUrl,
  };
};

export const checkConfig = () => {
  if (!configuration) {
    throw "API not configured";
  }
};

export const getConfig = () => {
  return configuration;
};

// Wrap HttpClient with a middleware that affects changes on the returned data from the server (only for Fig)
export const getClient = () => {
  return {
    post: async (options: HttpClientRequest) => {
      try {
        const response = await client.post(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    put: async (options: HttpClientRequest) => {
      try {
        const response = await client.put(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    patch: async (options: HttpClientRequest) => {
      try {
        const response = await client.patch(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    get: async (options: HttpClientRequest) => {
      try {
        const response = await client.get(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    head: async (options: HttpClientRequest) => {
      try {
        const response = await client.head(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    delete: async (options: HttpClientRequest) => {
      try {
        const response = await client.delete(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
    options: async (options: HttpClientRequest) => {
      try {
        const response = await client.options(options);
        handleRedirect(200, response?.data?.redirectUrl);
        return response;
      } catch (error: any) {
        handleRedirect(error.status, error?.data?.redirectUrl);
        throw error;
      }
    },
  };
};

const handleRedirect = (status: number, redirectUrl: string) => {
  if (redirectUrl) {
    if (status == 401) {
      window.location.assign(redirectUrl + serialize({redirect: window.location.pathname}));
    } else {
      window.location.assign(redirectUrl);
    }
    throw "Redirecting...";
  }
};
